import { graphql } from "react-relay";
import "@components/avatar-row-new/AvatarRow.gql";
import "./sso-admin-portal-button/SsoAdminPortalButton.gql";

export const adminPanelBillingGroupsPlansAndBillingFragments = {
  org: graphql`
    fragment AdminPanelBillingGroupsPlansAndBilling_org on Org {
      id
      primaryOrgCalendar
      ...AvatarRowNew_org
      ...SsoAdminPortalButton_org

      billingGroups {
        ... on BillingGroupList {
          list {
            ...SsoAdminPortalButton_billingGroup
            id
            name
            createdAtMillis
            invitePolicy
            type
            personListPaginatedErrorable {
              __typename
              ... on OrgPersonListPaginatedErrorable {
                __typename
                ... on GraphEntityError {
                  message
                }
                ... on OrgPersonListPaginated {
                  count
                }
              }
            }
            manualMembers {
              __typename
              ... on BillingGroupManualMemberList {
                list {
                  externalUserId
                  calendarId
                  userId
                  orgPerson {
                    __typename
                    ... on OrgPerson {
                      userId
                      personId
                      primaryCalendarId
                      isYou
                      signUpMillis
                      profile {
                        givenName
                        familyName
                      }
                    }
                    ... on GraphEntityError {
                      message
                      statusCode
                    }
                  }
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
            adminOrgPersons {
              __typename
              ... on OrgPersonList {
                list {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
            subscription {
              __typename
              ... on SubscriptionDetails {
                subscription {
                  id
                  type
                  productType
                  seatCount
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
            stripeCustomerPortalSession {
              __typename
              ... on StripeCustomerPortalSession {
                sessionUrl
                account {
                  accountId
                  stripeCustomerId
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      featureGrid {
        __typename
        ... on FeatureGrid {
          stateMetadata {
            primaryBillingGroupMetadata {
              subscription {
                id
              }
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }

      currentOrgPersons {
        __typename
        ... on OrgPersonList {
          list {
            ...AvatarPerson_orgPerson
            primaryCalendarId
            userId
            personId
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};

export const adminPanelBillingGroupsPlansAndBillingQuery = graphql`
  query AdminPanelBillingGroupsPlansAndBillingQuery($orgRelayId: ID!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        id
        ...AdminPanelBillingGroupsPlansAndBilling_org
      }
    }
  }
`;
